const maxDisplayCampaigns = 4;

export default [
  '$rootScope',
  'CampaignService', 'CampaignHistory', 'OffersService',
  class IndexController {
    constructor($rootScope, campaignService, campaignHistory, offersService) {
      this._$rootScope = $rootScope;
      this._campaignService = campaignService;
      this._history = campaignHistory;
      this._offersService = offersService;

      this.featuredCampaigns = [];
      this.trendingCampaigns = [];
      this.campaignHistory = [];
      this.getFeaturedCampaigns();
      this.getTrendingCampaigns();
      this.getRecentlyViewedCampaigns();

      this._email = '';
      this.subscribeState = null;
    }

    getFeaturedCampaigns() {
      this._campaignService.getFeatured(maxDisplayCampaigns)
        .then((data) => this.featuredCampaigns = data);
    }

    getRecentlyViewedCampaigns() {
      this.campaignHistory = this._history.getHistory(maxDisplayCampaigns);
    }

    getTrendingCampaigns() {
      this._campaignService.getTrending(8)
        .then((data) => this.trendingCampaigns = data);
    }

    emailSubscribe(isValid) {
      if (isValid) {
        this.subscribeState ='loading';
        this._offersService.subscribe(this.email, this._email)
          .then((res) => {
            this.subscribeState = 'success';
            this.email = '';
            this.subscribeForm.$setPristine();
          })
          .catch((err) => this.subscribeState = 'error');
      }
    }
  }
];



// WEBPACK FOOTER //
// ./source/client/pages/index/cui-index.ctrl.js